import { ActivityLogParser } from '@/parsers/activityLog'

export class PremiumReminderActivityLogParser extends ActivityLogParser {
    static attributeDataTypes = {
        'document_recipient': 'dispatchType',
        'files.name': 'textList',
        'invoice_date': 'date',
        'matched_contract_confirmed': 'boolean',
    }

    static showLogDetailsCreated = true
    static showLogDetailsDeleted = true
}
